import { Studio } from '@definitions/types/symfonyTypes'

import { STUDIO_IDS_EXCLUDED_FROM_CAMPAIGN_POPUP } from '../consts'

/**
 * Returns true if the studio should show the campaign popup when redeeming a coupon.
 * Excluded studios are matched by checking whether any excluded id is
 * contained in studio.id (supports prefixed ids e.g. "ip/uuid").
 */
export function isStudioEligible(studio: Studio): boolean {
  const { id } = studio

  if (id == null) {
    return true
  }

  return !STUDIO_IDS_EXCLUDED_FROM_CAMPAIGN_POPUP.some((excludedId) =>
    id.includes(excludedId)
  )
}
